'use client';

import { FeatherLock, FeatherUsers } from '@subframe/core';
import type { ReactNode } from 'react';

import { Button } from './Button';

interface AcessoRestritoProps {
  /** Quem acessa a área — vai em destaque no meio da frase. */
  descricao: ReactNode;
  /** O que fazer em vez de insistir: quem procurar e o que pedir. */
  dica: ReactNode;
  onVoltarParaInicio: () => void;
}

/**
 * Tela de área restrita das configurações do escritório. A página decide o gate pelo papel; este
 * card só explica o bloqueio e oferece a saída.
 */
export function AcessoRestrito({ descricao, dica, onVoltarParaInicio }: AcessoRestritoProps) {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center p-8">
      <div className="bg-default-background flex w-full max-w-md flex-col items-center gap-5 rounded-[16px] border border-solid border-neutral-200 p-8 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-neutral-50">
          <FeatherLock className="h-8 w-8 text-neutral-500" />
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="text-heading-2 font-heading-2 text-default-font">Área restrita</h2>
          <p className="text-body font-body text-subtext-color">{descricao}</p>
        </div>

        <div className="flex w-full items-start gap-3 rounded-[8px] bg-neutral-50 p-4 text-left">
          <FeatherUsers className="text-brand-600 mt-0.5 h-4 w-4 shrink-0" />
          <p className="text-caption font-caption text-subtext-color">{dica}</p>
        </div>

        <Button variant="brand-primary" size="medium" onClick={onVoltarParaInicio}>
          Voltar para a página inicial
        </Button>
      </div>
    </div>
  );
}
